import { FirebaseConfig } from '../types';

export const Firebase_Config: FirebaseConfig = {
  apiKey: "AIzaSyCxsxdatEx3irhQaikXqf9_M94nXrk7irA",
  authDomain: "statsapps-5b71c.firebaseapp.com",
  databaseURL: "https://statsapps-5b71c.firebaseio.com",
  projectId: "statsapps-5b71c",
  storageBucket: "",
  messagingSenderId: "78960443585",
  appId: "1:78960443585:web:2d8a472e435d558f",
};

export const API_BASE_URL = 'https://api.cmho.henri8.com';
export const LIVE_URL = 'https://cmho.henri8.com/live/#/';
export const SUPPORT_EMAIL = 'cmho@henri8.com';
export const SUPPORT_PHONE = '01 44 90 00 59';
